"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentInfoStep = void 0;
const CommonOnboardingStepId_1 = require("../../common/domain/CommonOnboardingStepId");
const BaseUserOnboardingStep_1 = require("../../common/domain/BaseUserOnboardingStep");
const PaymentInfo_1 = require("./PaymentInfo");
const validator_1 = require("@leavy/validator");
class PaymentInfoStep extends BaseUserOnboardingStep_1.BaseUserOnboardingStep {
    constructor() {
        super(...arguments);
        this.stepId = CommonOnboardingStepId_1.CommonOnboardingStepId.PAYMENT_INFO;
    }
    getDataConstructor() {
        return PaymentInfo_1.PaymentInfo;
    }
    getDefaultData() {
        return new PaymentInfo_1.PaymentInfo();
    }
}
__decorate([
    (0, validator_1.Type)(() => PaymentInfo_1.PaymentInfo),
    __metadata("design:type", PaymentInfo_1.PaymentInfo)
], PaymentInfoStep.prototype, "data", void 0);
exports.PaymentInfoStep = PaymentInfoStep;
//# sourceMappingURL=PaymentInfoStep.js.map